import { render, staticRenderFns } from "./BackgroundEnlargeImage.vue.js?vue&type=template&id=e6f6246c&scoped=true!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BackgroundEnlargeImage.vue?vue&type=template&id=e6f6246c&scoped=true"
var script = {}
import style0 from "./BackgroundEnlargeImage.vue.css?vue&type=style&index=0&id=e6f6246c&prod&scoped=true&lang=css!=!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BackgroundEnlargeImage.vue?vue&type=style&index=0&id=e6f6246c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6f6246c",
  null
  
)

export default component.exports
component.options.__file = "src/components-v2/presentation-editor/middle/BackgroundEnlargeImage.vue"
